import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./GenAIHomeHeader.css";
import GenAIMyLinks from "./GenAIMyLinks";
import GenAIMyAvatar from "./GenAIMyAvatar";
import { Link } from 'react-router-dom';

export default function GenAIHomeHeader({
    title,
    subtitle,
    showLinksText,
    avatarBg,
    outerAccent,
    customWidth,
    customHeight,
    pathName,
    updateBMAddForHome
}) {
    const [initials, setInitials] = useState("");
    useEffect(() => {
        try {
            let username = JSON.parse(localStorage.getItem('userdisplayName'));
            if (username) {
                let userNameSplit = username.split(" ");
                if (userNameSplit.length > 1) {
                    let firstName = userNameSplit[0];
                    let lastName = userNameSplit[1];
                    setInitials(`${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`)
                } else {
                    setInitials(`${username[0].toUpperCase()}`)
                }
            }
        } catch (error) {
        }
    }, []);
    return (
        <div className="ccai-root">
            <div className="ccai-card">
                <div className="ccai-header">
                    <div className="ccai-row">
                        <div className="ccai-title-wrap">
                            <div className="ccai-title">
                                {/* <Link to="/" >  <span className="ccai-title-main">{title}</span></Link> */}
                                {subtitle && <span className="ccai-title-sub"> {subtitle}</span>}
                            </div>
                        </div>
                        <div className="ccai-actions">
                            <GenAIMyLinks customWidth={customWidth} customHeight={customHeight} pathName={pathName} showLinksText={showLinksText} updateBMAddForHome={updateBMAddForHome} />
                            <GenAIMyAvatar customWidth={customWidth} customHeight={customHeight} pathName={pathName} avatarBg={avatarBg} outerAccent={outerAccent} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

GenAIHomeHeader.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    showLinksText: PropTypes.string,

    avatarBg: PropTypes.string,
    outerAccent: PropTypes.string,
};

GenAIHomeHeader.defaultProps = {
    title: "Content Center-AI",
    subtitle: "",
    showLinksText: "My Bookmarks",
    initials: "LA",
    avatarBg: "#0F68B2",
    outerAccent: "#8C3BBB",
};
